import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import Slider from 'rc-slider';
import * as classnames from 'classnames';
import 'rc-slider/assets/index.css';
import { findIndex } from 'lodash';
import PhotoBoothModal from '../../../../containers/PhotoBoothModal';

export const SIGNAL_COLORS = [
  [
    '#ffffff',
    '#ffcccc',
    '#ffcc99',
    '#ffff99',
    '#ffffcc',
    '#99ff99',
    '#99ffff',
    '#ccffff',
    '#ccccff',
    '#ffccff'
  ],
  [
    '#cccccc',
    '#ff6666',
    '#ff9966',
    '#ffff66',
    '#ffff33',
    '#66ff99',
    '#33ffff',
    '#66ffff',
    '#9999ff',
    '#ff99ff'
  ],
  [
    '#c0c0c0',
    '#ff0000',
    '#ff9900',
    '#ffcc66',
    '#ffff00',
    '#33ff33',
    '#66cccc',
    '#33ccff',
    '#6666cc',
    '#cc66cc'
  ],
  [
    '#999999',
    '#cc0000',
    '#ff6600',
    '#ffcc33',
    '#ffcc00',
    '#33cc00',
    '#00cccc',
    '#3366ff',
    '#6633ff',
    '#cc33cc'
  ],
  [
    '#666666',
    '#990000',
    '#cc6600',
    '#cc9933',
    '#999900',
    '#009900',
    '#339999',
    '#3333ff',
    '#6600cc',
    '#993399'
  ],
  [
    '#333333',
    '#660000',
    '#993300',
    '#996633',
    '#666600',
    '#006600',
    '#336666',
    '#000099',
    '#333399',
    '#663366'
  ],
  [
    '#000000',
    '#330000',
    '#663300',
    '#663333',
    '#333300',
    '#003300',
    '#003333',
    '#000066',
    '#330099',
    '#330033'
  ]
];

const customStyle = {
  width: '25rem'
};

const colorToHex = color => {
  let hex = Number(color).toString(16);
  if (hex.length < 2) {
    hex = `0${hex}`;
  }
  return hex;
};

const fullColorHex = (r, g, b) => {
  return colorToHex(r) + colorToHex(g) + colorToHex(b);
};

class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.selectColorHandler = this.selectColorHandler.bind(this);
    this.validateHandler = this.validateHandler.bind(this);
    this.sliderChanged = this.sliderChanged.bind(this);
    this.requestClose = this.requestClose.bind(this);
    this.state = {
      selectedColor: null,
      alphaValue: 50
    };
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.isOpen === true && prevProps.isOpen === false && this.props.selectedSettings) {
      let selectedColor;
      if (this.props.selectedSettings.color) {
        const hex = fullColorHex(
          this.props.selectedSettings.color[0],
          this.props.selectedSettings.color[1],
          this.props.selectedSettings.color[2]
        );

        const colorX = findIndex(SIGNAL_COLORS, signalRow => {
          return signalRow.indexOf(`#${hex}`) > -1;
        });

        if (colorX !== -1) {
          const colorY = SIGNAL_COLORS[colorX].indexOf(`#${hex}`);
          selectedColor = [colorX, colorY];
        }
      }

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        alphaValue: Math.floor(this.props.selectedSettings.opacity * 100),
        selectedColor
      });
    }
  }

  requestClose() {
    this.setState({
      selectedColor: null,
      alphaValue: 50
    });

    this.props.onRequestClose();
  }

  selectColorHandler(indexX, indexY) {
    this.setState({
      selectedColor: [indexX, indexY]
    });
  }

  validateHandler() {
    if (!this.state.selectedColor) {
      this.requestClose();
      return;
    }

    this.props.okHandler(
      SIGNAL_COLORS[this.state.selectedColor[0]][this.state.selectedColor[1]],
      this.state.alphaValue
    );

    this.setState({
      selectedColor: null,
      alphaValue: 100
    });
  }

  sliderChanged(value) {
    this.setState({
      alphaValue: value
    });
  }

  renderColors() {
    const isColorSelected = (indexX, indexY, self) => {
      if (this.state.selectedColor) {
        return this.state.selectedColor[0] === indexX && this.state.selectedColor[1] === indexY;
      }
      return false;
    };

    return SIGNAL_COLORS.map((row, indexX) => {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <Grid.Row key={indexX} className="colorsRow">
          {row.map((color, indexY) => {
            const style = {
              backgroundColor: color
            };

            const squareClassname = classnames({
              colorUnit: true,
              selected: isColorSelected(indexX, indexY)
            });

            return (
              <Grid.Column
                key={indexY} // eslint-disable-line react/no-array-index-key
                style={style}
                className={squareClassname}
                onClick={() => {
                  this.selectColorHandler(indexX, indexY);
                }}
              />
            );
          })}
        </Grid.Row>
      );
    });
  }

  render() {
    return (
      <PhotoBoothModal
        {...this.props}
        onRequestClose={this.requestClose}
        footerHandler={() => {
          this.validateHandler();
        }}
        width={customStyle.width}
        title={this.props.constructName}
        className="colorPicker"
        customStyle={{ width: '350px' }}
      >
        <div>
          <Grid>
            <Grid.Row className="colorsHeader">
              <Grid.Column width={12}>Select a color</Grid.Column>
            </Grid.Row>
            <Grid className="colors" width={16}>
              {this.renderColors()}
            </Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Slider onChange={this.sliderChanged} defaultValue={this.state.alphaValue} />
              </Grid.Column>
              <br />
              <Grid.Column width={4}>{this.state.alphaValue}%</Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </PhotoBoothModal>
    );
  }
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/ColorPicker.js